import * as React from 'react';
import { connect } from 'react-redux';
import Rest from '../../webapi/Rest';
import { DateFormatter, i18n } from 'arm-common'
import DocumentiActions from './DocumentiActions';
import { AppConstants } from '../../constants/AppConstants';
import DataSourceActions from '../dataSource/DataSourceActions';

class TabelaDataSource extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[TabelaDataSource.jsx] ";
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        let columns = [
            { checkbox: true, field: "checked", visible: !this.props.disabled },
            { field: 'id', title: 'ID', sortable: 'true' },
            { field: 'alias', title: 'Alias', sortable: 'false' },
            { field: 'dataUpdate', title: i18n('ARM_CORE_PRINT.DATA_ULTIMA.MODIFICA','Data ultima modifica'), sortable: 'true', formatter: this.dataFormatter },
            { field: 'idUserUpdate',title: i18n('ARM_CORE_PRINT.MODIFICATO','Modificato da'), sortable: 'true' },
            { field: 'info', title: i18n('ARM_CORE_PRINT.SHARED.DETTAGLI', 'Dettagli'), formatter: this.columnDetail }
        ];

        $(this.refs.ListDataSource).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            clickToSelect: true,
            maintainMetaData: true,
            maintainSelected: true,
            // onClickRow: (row, $element, field) => this.deatilsOnClick(row, $element, field),
            pagination: true,
        });

        if (this.props.document && this.props.document.listDataSources) {
            $(this.refs.ListDataSource).bootstrapTable('load', this.props.document.listDataSources);
        }
    }

    // componentWillReceiveProps(nextProps) {
    //     console.log(this.componentName + ' componentWillReceiveProps');

    //     if (nextProps.document.listDataSources && nextProps.document.listDataSources !== this.props.document.listDataSources) {
    //         console.log("\t rows: " + (nextProps.document.listDataSources !== null ? nextProps.document.listDataSources.length : "NULL"));
    //         $(this.refs.ListDataSource).bootstrapTable('load', nextProps.document.listDataSources);
    //     }
    // }

    componentDidUpdate(prevProps) {
        if ((this.props.document.listDataSources && this.props.document.listDataSources !== prevProps.document.listDataSources)
            || this.props.disabled !== prevProps.disabled) {

            console.log("\t rows: " + (this.props.document.listDataSources !== null ? this.props.document.listDataSources.length : "NULL"));
            $(this.refs.ListDataSource).bootstrapTable('destroy')
            let columns = [
                { checkbox: true, field: "checked", visible: !this.props.disabled },
                { field: 'id', title: 'ID', sortable: 'true' },
                { field: 'alias', title: 'Alias', sortable: 'false' },
                { field: 'dataUpdate', title: i18n('ARM_CORE_PRINT.DATA_ULTIMA.MODIFICA','Data ultima modifica') , sortable: 'true', formatter: this.dataFormatter },
                { field: 'idUserUpdate',title: i18n('ARM_CORE_PRINT.MODIFICATO','Modificato da'), sortable: 'true' },
                { field: 'info', title: i18n('ARM_CORE_PRINT.SHARED.DETTAGLI', 'Dettagli'), formatter: this.columnDetail }
            ];

            $(this.refs.ListDataSource).bootstrapTable({
                columns: columns,
                idField: "id",
                sortable: true,
                search: true,
                showColumns: true,
                showExport: true,
                exportDataType: 'all',
                exportTypes: ['csv', 'excel'],
                clickToSelect: true,
                maintainMetaData: true,
                maintainSelected: true,
                onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
                pagination: true,
            });

            if (this.props.document.listDataSources)
                $(this.refs.ListDataSource).bootstrapTable('load', this.props.document.listDataSources);
        }
    }

    dataFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    columnDetail(value, row, index) {
        console.log(this.componentName + " columnDetail: " + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm' href='#/dataSource/create'><i class='fas fa-info fa-fw' data-toggle='tooltip' data-placement='top' title='Visualizza'/></button>";
        return temp;
    }

    detailsOnClick(row, $element, field) {
        if (field === "info") {
            this.props.changeStatDett(true);
            this.props.getDataSource(row.id);
            this.props.history.push({ pathname: '/dataSource/create', state: { id: row.id, alias: row.alias } });
        }
    }

    render() {
        const baseUrl = Rest.restBaseurl;
        return (
            <table ref="ListDataSource" className={AppConstants.CLASS_BOOSTRAP_TABLE} />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getDataSource(idDataSource) {
            return dispatch(DocumentiActions.getDataSource(idDataSource));
        },
        changeStatDett(statusDett) {
            return dispatch(DataSourceActions.changeStatDett(statusDett));
        },
    }
};

function mapStateToProps(state) {
    return {
        listaDataSource: state.documentiReducer.listaDataSource,
        document: state.documentiReducer.nuovoDoc
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TabelaDataSource);
